import type { ItemType, PageId } from "core/entities";
import { useCallback } from "react";
import { useCentrixFetch } from "./useCentrixFetch";

export function useAddUserLog() {
  const centrixFetch = useCentrixFetch();

  return useCallback(
    async <T extends ItemType>(
      type: T,
      id: T extends "Page" ? PageId : string
    ) => {
      const createLogResponse = await centrixFetch({
        method: "post",
        path: "/api/app/user-logs",
        body: { itemType: type, itemId: id },
      });
      if (!createLogResponse.ok) {
        // eslint-disable-next-line no-console
        console.error(`failed to log itemType:${type}:${id}`);
      }
    },
    [centrixFetch]
  );
}
